import TrainingWizardStepTwo, { validator } from './TrainingWizardStepTwo'

export { validator }
export default TrainingWizardStepTwo
